import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";

import * as componentTypes from "../../../../../constants/componentTypes";
import * as modelHelper from "../../../../../helpers/modelHelper";
import * as navigationActions from "../../../../../actions/navigationActions";
import * as windowService from "../../../../../services/windowService";
import Modal from "../../../../global/generic/Modal";
import CloseButton from "../../../../global/generic/CloseButton";

class VersionModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLocalhost: true
        };
    }

    componentDidMount = () => {
        let isLocalhost = false;

        if (this.props.activeServer !== null) {
            let localhosts = windowService.getLocalhosts();

            isLocalhost = localhosts.includes(this.props.server.ip);
        }

        this.setState({
            isLocalhost: isLocalhost
        });
    };

    handleCloseModalClick = () => {
        this.props.dispatchCloseVersionModalAction();
    };

    handleOpenDebugModalClick = () => {
        this.props.dispatchOpenDebugModalAction();
    };

    getIpAddress = () => {
        if (this.state.isLocalhost) {
            return (
                <li>
                    <Translate value="general.ip" />: {this.props.server.ip}
                </li>
            );
        }

        return (
            <li>
                <Translate value="general.ip" />: <span className="label label-danger">{this.props.server.ip}</span>
            </li>
        );
    };

    getContent = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <div className="col-12">
                    <span>
                        <Translate value="general.client" />:
                    </span>
                    <ul>
                        <li>
                            <Translate value="general.version" />: {this.props.clientVersion}
                        </li>
                        <li>
                            <Translate value="general.revision" />: {this.props.clientRevision}
                        </li>
                    </ul>
                </div>
                <div className="col-12">
                    <span>
                        <Translate value="server.server" />:
                    </span>
                    <ul>
                        <li>
                            <Translate value="general.nameTitle" />: {this.props.server.name}
                        </li>
                        <li>
                            <Translate value="customRedlike.uuid" />:{" "}
                            {this.props.server.uuid !== null ? this.props.server.uuid : ""}
                        </li>
                        <li>
                            <Translate value="general.version" />:{" "}
                            {this.props.server.version !== null ? this.props.server.version : ""}
                        </li>
                        <li>
                            <Translate value="server.computerId" />:{" "}
                            {this.props.server.computerId !== null ? this.props.server.computerId : ""}
                        </li>
                        <li>
                            <Translate value="license.uuid" />: {this.props.licenseUuid}
                        </li>
                        {this.getIpAddress()}
                    </ul>
                </div>
                <div className="col-12">
                    <span>
                        <Translate value="general.database" />:
                    </span>
                    <ul>
                        <li>
                            <Translate value="general.nameTitle" />:{" "}
                            {this.props.database ? this.props.database.name : ""}
                        </li>
                        <li>
                            <Translate value="customRedlike.uuid" />:{" "}
                            {this.props.database ? this.props.database.uuid : ""}
                        </li>
                        <li>
                            <Translate value="general.version" />:{" "}
                            {this.props.database && this.props.database.main ? this.props.database.main.version : ""}
                        </li>
                        <li>
                            <Translate value="general.localVersion" />:{" "}
                            {this.props.database ? this.props.database.local.version : ""}
                        </li>
                    </ul>
                </div>
            </React.Fragment>,
            "col-12 flex flex-wrap slim-scroll flex-row-gap-10px"
        );
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <span onDoubleClick={this.handleOpenDebugModalClick} style={{cursor: "pointer", marginRight: "auto"}}>
                    &nbsp;
                </span>
                <CloseButton onClick={this.handleCloseModalClick} />
            </React.Fragment>
        );
    };

    render() {
        return (
            <Modal
                className="software-version-modal "
                modalId={this.props.tabId}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(<Translate value="customRedlikeSettings.swVersion" />)}
                content={this.getContent()}
                footer={this.getFooter()}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        clientVersion: store.module.softwareVersion,
        clientRevision: store.module.softwareRevision,
        server: store.server.activeServer,
        database: store.server.activeDatabase,
        licenseUuid: store.license.uuid
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseVersionModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.INTERGAMMA_SW_VERSIONS_MODAL));
        },
        dispatchOpenDebugModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.INTERGAMMA_SW_VERSIONS_MODAL));
            dispatch(navigationActions.openModal(componentTypes.MODAL_NO_TAB, componentTypes.DEBUG_MODAL));
        }
    };
};

export default VersionModal = connect(mapStoreToProps, mapDispatchToProps)(VersionModal);
